export const props: TPageProps = {
    name: 'warranty',
    list: 'client',
    label: 'Поиск',
    urlShow: 'api.client.show',
}
